import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Modal, ModalProps } from 'dig-components/modal';
import { Button } from 'dig-components/buttons';
import { RebrandTheme } from 'hello-react/components/rebrand';
import HfReactHelper from 'hellosign/components/hf-react-helper';

const messages = defineMessages({
  close: {
    id: '',
    description: 'Text for a button which closes an interface.',
    defaultMessage: 'Close',
  },
});

function BulkSendModal({
  onRequestClose,
  ...props
}: ModalProps) {
  const intl = useIntl();

  return (
    <Modal
      isCentered
      withCloseButton={intl.formatMessage(messages.close)}
      onRequestClose={onRequestClose}
      {...props}
    >
      {/* This content is portaled and requires new rebrand theme context */}
      <RebrandTheme>
        <Modal.Header hasBottomSpacing="title-standard">
          <Modal.Title>
            <FormattedMessage
              id=""
              description="Upsell modal that appears in webapp, when users click on homepage sidebar bulkSend link"
              defaultMessage="Upgrade for bulk send" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormattedMessage
            id=""
            description="text upselling bulk send when a non Enterprise Plus customer clicks on bulk send"
            defaultMessage="Bulk send is the easiest way to send a single-signer template to many people all at once. Contact us to learn more and upgrade your plan." />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="transparent"
            onClick={onRequestClose}
            data-qa-ref="global-nav-bulk-send-modal-close"
          >
            <FormattedMessage
              id=""
              description="Close button in upsell modal that appears in webapp, when users click on homepage sidebar bulkSend link"
              defaultMessage="Close" />
          </Button>
          <Button
            variant="primary"
            href={HfReactHelper.getWebflowUrl('form/contact-us-general')}
            data-qa-ref="global-nav-bulk-send-modal-contact"
          >
            <FormattedMessage
              id=""
              description="Contact-us button in upsell modal that appears in webapp, when users click on homepage sidebar bulkSend link. When clicked, will send users to a form that sales will receive"
              defaultMessage="Contact us" />
          </Button>
        </Modal.Footer>
      </RebrandTheme>
    </Modal>
  );
}

export default BulkSendModal;
